import { type ZodSchema, z } from 'zod';

import type { USAddress } from '@/typings/api-models';

export const addressSchema = (required: boolean): ZodSchema =>
  z.object({
    city: required ? z.string().nonempty('City is required') : z.string().optional(),
    line1: required ? z.string().nonempty('Street Address is required') : z.string(),
    line2: z.string().optional(),
    state: required ? z.string().nonempty('State is required') : z.string().optional(),
    zip: required
      ? z
          .string()
          .nonempty('Zip is required')
          .regex(/^\d{5}$/, 'Zip code must be exactly 5 digits')
      : z
          .string()
          .regex(/^\d{5}$/, 'Zip code must be exactly 5 digits')
          .optional(),
  });

export const DEFAULT_VALUE: USAddress = {
  city: '',
  line1: '',
  line2: '',
  state: '',
  zip: '',
};

export type AutoCompleteAddress = Partial<Omit<USAddress, 'line2'>>;
